import { useEffect } from "react";
import { ThreePlanogram } from "../../store/types";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import { createThreeMesh } from "../../store/utils/three";
import { Color } from "src/elements";

interface Props {
  bay: PlanogramBay;
  bayIndex: number;
  three: ThreePlanogram;
}

export const BayBase = ({ bay, bayIndex, three }: Props) => {
  useEffect(() => {
    const bayBase = createThreeMesh({
      scene: three.scene,
      width: bay.width,
      height: bay.baseHeight,
      depth: bay.depth,
      x: bay.getXLeft(),
      y: 0,
      z: 0,
      color: Color.sand300,
      renderOrder: 1,
      label: `Bay ${bayIndex + 1}`,
    });

    return () => {
      bayBase.cleanUp();
    };
  }, [bay, bayIndex, three]);

  return null;
};
